import React from 'react';

import { getThemeClass } from '../../tools/textTools';
import ContentfulImage from '../Common/ContentfulImage';
import * as styles from './CenteredTextOverlay.module.scss';
import PageSection from './PageSection';

export default function CenteredTextOverlay({ section }) {
  const themeClass = getThemeClass(section.colorTheme?.themeName);

  return (
    <PageSection
      slim
      className={themeClass}
      innerClassName={styles.section}
      style={{ paddingBlock: 0 }}
      data-analytics-component={'centered-text-overlay'}
      data-analytics-id={section.title}
    >
      <ContentfulImage
        className={[styles.image, styles.desktop].join(' ')}
        imageFragment={section.mainImage}
        alt={section.title}
      />
      <ContentfulImage
        className={[styles.image, styles.mobile].join(' ')}
        imageFragment={section.backgroundImage}
        alt={section.title}
      />
      <div className={styles.copy}>
        <span className={[styles.eyebrow, 'themed-eyebrow'].join(' ')}>{section.subtitle}</span>
        <h2 className={styles.title}>{section.title}</h2>
      </div>
    </PageSection>
  );
}
